'use client';

/** /banner 진입 시 메인배너 전체보기 (코너 배너 컨테이너 재사용) */
import MyHeartManager from '@components/common/MyHeartManager';
import { GaLog } from '@components/common/PageView';
import { GlobalPagePropsProvider } from '@contexts/GlobalPagePropsContext';
import React from 'react';
import type { JSX } from 'react';

const CategoryCornerBannerPageContainer = React.lazy(
  () =>
    import('@components/pages/categoryCorner/CategoryCornerBannerPageContainer')
);

function CategoryBannerView(): JSX.Element {
  return (
    <GlobalPagePropsProvider>
      <MyHeartManager />
      <GaLog pageTitle="카테고리>전체보기" />
      <CategoryCornerBannerPageContainer />
    </GlobalPagePropsProvider>
  );
}

export default CategoryBannerView;
